export default "__VITE_ASSET__z3cWPsEC__"